var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFoundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ill/not-found_v1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 37,
    cy: 37,
    r: 36.5,
    stroke: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M63 63L82.5 82.5",
    stroke: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_2",
    d: "M52.3283 49.9592C48.6606 45.6981 43.2275 43 37.1642 43C31.1009 43 25.6678 45.6981 22 49.9592",
    stroke: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    cx: 49.5,
    cy: 27.5,
    r: 1.5,
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    cx: 24.5,
    cy: 27.5,
    r: 1.5,
    fill: "#D1D2D6"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundIcon);
export default __webpack_public_path__ + "static/media/not-found-icon.636bd7913c116ee4f4021c0a75cdfe5e.svg";
export { ForwardRef as ReactComponent };